export default "__VITE_ASSET__BXAeO$7u__"